var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:_vm.reference,model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"form-tab"},[_vm._v(_vm._s(_vm.formTitle))]),_c('v-row',{staticClass:"pt-4",class:{ 'boxed': _vm.boxed }},[_vm._t("fields")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }